import React, { useEffect } from "react";
import CloseButton from "./elements/CloseButton";

const Modal = ({ children, open, onClose, icon, title, className }) => {
    useEffect(() => {
        if (!open) return;
    }, [open]);

    return (
        <>
            {open && (
                <div className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 font-sans`}>
                    <div className={`bg-background-light rounded-xl shadow-2xl max-w-6xl relative border-2 border-accent-main m-4 ${className}`}>
                        <div className="relative m-1 p-6" style={{ maxHeight: '85vh', overflowY: 'auto' }}>
                            <CloseButton onClick={onClose} />
                            <h3 className="text-2xl font-bold text-primary-dark mb-4 -mt-2 mr-4 text-center flex items-center justify-center">
                                {/* Guarded: cloneElement(undefined) THROWS, so a caller that forgot an
                                    icon used to render nothing at all - the modal never appeared, with
                                    no error visible in the UI. That cost a staging deploy and three
                                    failed E2E specs to diagnose. A missing icon is now a missing icon. */}
                                {icon && React.cloneElement(icon, { className: 'w-8 h-8 mr-3 text-accent-main flex-shrink-0' })}
                                {title}
                            </h3>

                            <div className="flex flex-col sm:flex-row gap-8 p-4 bg-primary-light border border-accent-main rounded-xl shadow">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Modal;